import { FC } from 'react';

import styles from './styles';

const SliderItemTitle: FC = ({ children }) => (
  <span className={styles.wrapper}>{children}</span>
);

export default SliderItemTitle;
